export const DEFAULT_CHIPS = {
  Freemium: false,
  Paid: false,
  'No Circle': false,
  Unverified: false,
};

export function defaultFilters() {
  return {
    state: '',
    plan: '',
    product: '',
    trustedCircle: '',
    verification: '',
    onboardingStatus: 'complete',
    sort: 'newest',
    search: '',
  };
}

/**
 * Merge quick-chip toggles into filter object (chips override dropdown when active).
 */
export function mergeChipFilters(filters, chips = DEFAULT_CHIPS) {
  const merged = { ...filters };
  if (chips.Freemium) merged.plan = 'free';
  if (chips.Paid) merged.plan = '__paid__';
  if (chips['No Circle']) merged.trustedCircle = 'no_circle';
  if (chips.Unverified) merged.verification = 'unverified';
  return merged;
}

/**
 * Build query params for GET /admin/users from UI filters + chips.
 */
export function toApiParams(filters, chips = DEFAULT_CHIPS, page = 1, limit = 20, extra = {}) {
  const merged = mergeChipFilters(filters, chips);
  const params = { page, limit, ...extra };

  if (merged.state) params.state = merged.state;
  if (merged.plan) params.plan = merged.plan;
  if (merged.product) params.product = merged.product;
  if (merged.trustedCircle) params.trustedCircle = merged.trustedCircle;
  if (merged.verification) params.verification = merged.verification;
  if (merged.onboardingStatus) params.onboardingStatus = merged.onboardingStatus;
  if (merged.sort) params.sort = merged.sort;
  if (merged.search?.trim()) params.search = merged.search.trim();

  return params;
}

export const PLAN_COLORS = {
  free: { background: '#FFFBEB', color: '#B45309' },
  Freemium: { background: '#FFFBEB', color: '#B45309' },
  'Free Plan': { background: '#FFFBEB', color: '#B45309' },
  single: { background: '#EFF6FF', color: '#1D4ED8' },
  Single: { background: '#EFF6FF', color: '#1D4ED8' },
  'Single Plan': { background: '#EFF6FF', color: '#1D4ED8' },
  group: { background: '#F0FDF4', color: '#15803D' },
  Group: { background: '#F0FDF4', color: '#15803D' },
  'Group Plan': { background: '#F0FDF4', color: '#15803D' },
  Guardian: { background: '#EFF6FF', color: '#1D4ED8' },
  Response: { background: '#F0FDF4', color: '#15803D' },
  Threat: { background: '#FFF1F2', color: '#BE123C' },
  Sponsored: { background: '#F5F3FF', color: '#6D28D9' },
  Pilot: { background: '#ECFEFF', color: '#0E7490' },
  Promo: { background: '#FFF1F2', color: '#BE123C' },
  Paid: { background: '#EFF6FF', color: '#1D4ED8' },
};

const SLUG_FALLBACK_COLORS = [
  { background: '#F5F3FF', color: '#6D28D9' },
  { background: '#ECFEFF', color: '#0E7490' },
  { background: '#FFF7ED', color: '#C2410C' },
  { background: '#FDF4FF', color: '#A21CAF' },
];

export function getPlanStyle(planKey) {
  if (!planKey) return { background: '#F1F5F9', color: '#475569' };
  const raw = String(planKey);
  const lower = raw.toLowerCase();
  if (PLAN_COLORS[lower]) return PLAN_COLORS[lower];
  if (PLAN_COLORS[raw]) return PLAN_COLORS[raw];
  const titled = raw.charAt(0).toUpperCase() + raw.slice(1);
  if (PLAN_COLORS[titled]) return PLAN_COLORS[titled];
  const idx = Math.abs(lower.split('').reduce((a, c) => a + c.charCodeAt(0), 0)) % SLUG_FALLBACK_COLORS.length;
  return SLUG_FALLBACK_COLORS[idx];
}

export function formatRelativeDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return '—';
  const daysAgo = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (daysAgo === 0) return 'Today';
  if (daysAgo === 1) return '1 day ago';
  if (daysAgo < 7) return `${daysAgo} days ago`;
  if (daysAgo < 30) return `${Math.floor(daysAgo / 7)} weeks ago`;
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
